import DeleteButton from './DeleteButton'
import EditButton from './EditButton'

const ActionComponents = ({ canEdit, canDelete, openEditModal, openDeleteModal }) => (
  <>
    {canEdit && <EditButton onClick={openEditModal} />}
    {canDelete && <DeleteButton onClick={openDeleteModal} />}
  </>
)

export default ActionComponents
